import { query, request } from '@/utils/request';

const urls = {
  orgEconomicSubjectList: '/zlb/budget/info/query-relation-budget', // 单位预算指标
  budgetDetail: '/zlb/budget/info/detail', // 预算指标详情查询
  budgetUsedRecord: '/zlb/budget/manage/query-budget-used-record', // 预算日志
  relationProject: '/zlb/budget/ep/project-use/query-relation-project-use', // 查询场景关联的项目（分页）
  cancelRelation: '/zlb/budget/ep/project-use/cancel-relation-project-use', // 支出场景取消关联项目使用情况
  noRelationProject: '/zlb/budget/ep/project-use/query-no-relation-project-use', // 查询场景未关联的项目（分页）
  relationProjects: '/zlb/budget/ep/project-use/relation-project-use', // 支出场景关联项目使用情况
  importRelationSubmit: '/zlb/budget/import/budget-scenes-relation/submit', // 导入任务提交
};

export async function reqOrgEconomicSubjectList(data) {
  return request(urls.orgEconomicSubjectList, { method: 'POST', data });
}

export async function reqBudgetDetail(params) {
  return request(`${urls.budgetDetail}/${params.budgetId}`);
}

export async function getBudgetUsedRecord(data) {
  return request(urls.budgetUsedRecord, { method: 'POST', data });
}

export async function getRelationProjectList(data) {
  return query(urls.relationProject, { method: 'POST', data });
}

export async function cancelProjectRelation(data) {
  return query(urls.cancelRelation, { method: 'POST', data });
}

export async function getNoRelationProjectList(data) {
  return query(urls.noRelationProject, { method: 'POST', data });
}

export async function relationProjects(data) {
  return query(urls.relationProjects, { method: 'POST', data });
}

export async function importRelationSubmit(data) {
  return query(urls.importRelationSubmit, { method: 'POST', data });
}
